import type { RouteObject } from "react-router";
import { RequireRole } from "@/components/layout/require-role";

// Feature screens register here; each feature folder owns its pages and is
// loaded on first visit (route-level code splitting).
// Navigation entries live in components/layout/nav.ts.
const page = (load: () => Promise<{ Component: React.ComponentType }>) => ({ lazy: load });

export const officeRoutes: RouteObject[] = [
  { index: true, ...page(() => import("./insights/dashboard-page").then((m) => ({ Component: m.DashboardPage }))) },
  { path: "articles", ...page(() => import("./articles/articles-page").then((m) => ({ Component: m.ArticlesPage }))) },
  { path: "report", ...page(() => import("./insights/report-page").then((m) => ({ Component: m.ReportPage }))) },
  { path: "calendar", ...page(() => import("./articles/calendar-page").then((m) => ({ Component: m.CalendarPage }))) },
  { path: "articles/:articleId", ...page(() => import("./articles/article-detail-page").then((m) => ({ Component: m.ArticleDetailPage }))) },
  { path: "settings", ...page(() => import("./offices/settings-page").then((m) => ({ Component: m.OfficeSettingsPage }))) },
  { path: "setup", ...page(() => import("./offices/setup-page").then((m) => ({ Component: m.SetupPage }))) },
  { path: "notes", ...page(() => import("./notes/notes-page").then((m) => ({ Component: m.NotesPage }))) },
  { path: "initiatives", ...page(() => import("./initiatives/initiatives-page").then((m) => ({ Component: m.InitiativesPage }))) },
  { path: "supervisors", ...page(() => import("./offices/supervisors-page").then((m) => ({ Component: m.SupervisorsPage }))) },
  { path: "wordpress", ...page(() => import("./wordpress/wordpress-page").then((m) => ({ Component: m.WordpressPage }))) },
  {
    element: <RequireRole roles={["admin", "partner"]} />,
    children: [
      { path: "keywords", ...page(() => import("./keywords/keywords-page").then((m) => ({ Component: m.KeywordsPage }))) },
      { path: "review", ...page(() => import("./review/review-page").then((m) => ({ Component: m.ReviewPage }))) },
    ],
  },
  {
    element: <RequireRole roles={["admin"]} />,
    children: [{ path: "usage", ...page(() => import("./insights/usage-page").then((m) => ({ Component: m.OfficeUsagePage }))) }],
  },
];

export const adminRoutes: RouteObject[] = [
  { path: "offices", ...page(() => import("./offices/admin-offices-page").then((m) => ({ Component: m.AdminOfficesPage }))) },
  { path: "accounts", ...page(() => import("./offices/admin-accounts-page").then((m) => ({ Component: m.AdminAccountsPage }))) },
  { path: "usage", ...page(() => import("./insights/usage-page").then((m) => ({ Component: m.AdminUsagePage }))) },
];
